import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../controller/users/usersController";
import { fetchStartupContents } from "../graphQL/controller/startupContentsController";
import Loading from "../components/Loading";

const ProtectedRoute = ({ children }) => {
    const dispatch = useDispatch();
    const { credObj } = useSelector((store) => store.auth);
    const { currentUser, isLoading } = useSelector((store) => store.users);
    const { hasAttemptedFetch, isLoading: isStartupLoading } = useSelector((store) => store.startupContents);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const OS = queryParams.get("OS");
    const isNativeStripePayment = location.pathname === "/subscription" && (OS === "Android" || OS === "iOS");
    const isStripeRedirect = location.pathname === "/subscription/success" || location.pathname === "/subscription/cancel";

    useEffect(() => {
        if (!credObj) return;

        if (!currentUser?._id) {
            dispatch(getCurrentUser());
        }

        if (!hasAttemptedFetch && !isStartupLoading) {
            dispatch(fetchStartupContents());
        }
    }, [credObj, currentUser?._id, hasAttemptedFetch, isStartupLoading, dispatch]);

    if (isStripeRedirect) return children;

    if (!credObj && !isNativeStripePayment) {
        return <Navigate to='/landing' />
    }

    if (credObj && !currentUser?._id && isLoading) {
        return <Loading center />;
    }

    if (credObj && currentUser?.isEmailVerified === false) {
        return (
            <Navigate
                to={`/verify-email?email=${encodeURIComponent(currentUser?.email || "")}`}
                replace
                state={{ email: currentUser?.email }}
            />
        );
    }
    return children;
};
export default ProtectedRoute;